<template>
  <div class="w-full h-full flex flex-col">
    <flow-header
      :bot-name="
        getFlowRecord.agent_bot ? getFlowRecord.agent_bot.name : 'Flow'
      "
    />
    <div v-if="isLoading" class="flex items-center justify-center h-full">
      <div class="loader" />
    </div>
    <iframe v-else :src="getFlowRecord.node_red.uri" title="Flow View" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FlowHeader from './components/FlowHeader.vue';

export default {
  components: {
    FlowHeader,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    flowId: Number,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters('flowManager', ['getUiFlags', 'getFlowRecord']),
    ...mapGetters({
      currentUserId: 'getCurrentUserID',
    }),
  },
  async mounted() {
    await this.$store.dispatch('flowManager/show', this.flowId);
    this.isLoading = false;

    if (this.getFlowRecord.user_id !== this.currentUserId) {
      this.$router.push({
        name: 'flow_dashboard',
      });
    }
  },
  methods: {},
};
</script>

<style>
iframe {
  height: 99.5%;
  width: 100%;
  border: none;
}

.content-box {
  padding: 0px;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
